module.exports = __webpack_public_path__ + "static/media/table.92688dd5.png";